<template>
    <b-navbar :class="brand ? 'p-0 pl-4 pr-4' : ''"  toggleable="lg" :type="type" :variant="variant" :fixed="fixed" :sticky="sticky" :style="navItemAlign == 'center' ? {'justify-content': 'center','height':'60px'} : {}">
        <b-navbar-brand href="/" v-if="brand  && !toggle && !navs" class="d-none d-sm-block">
            <img :src="brand.img" class="d-inline-block align-top" style="height:50px">
            <!-- {{brand.text}} -->
        </b-navbar-brand>

        <b-navbar-brand href="/" v-if="brand && toggle && navs"  class="d-block d-sm-none">
            <img :src="brand.img" class="d-inline-block align-top" style="height:50px">
            <!-- {{brand.text}} -->
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse" v-if="toggle && navs"></b-navbar-toggle>

        <b-collapse id="nav-collapse" v-if="navs" is-nav :style="navItemAlign == 'center' ? {'flex-grow':'unset'} : {}">
            <b-navbar-nav class="ml-auto" v-if="navs.length > 0">
                <template  v-for="(item,index) in navs">
                    <b-nav-item  @click="onClickNavItem(item)"  :active="(avthveNav && avthveNav.name == item.name) || (!avthveNav && item.name == '首页')" :key="index" v-if="!item.hasOwnProperty('children') || item.children.length < 1">{{item.name}}</b-nav-item>
                    <b-nav-item-dropdown right  :key="index" v-if="item.hasOwnProperty('children') && item.children.length > 0" :class="avthveNav && avthveNav.name == item.name ? 'active' : ''">
                        <!-- Using 'button-content' slot -->
                        <template v-slot:button-content>
                            <!-- {{ avthveNav && avthveNav.name !== item.name || !avthveNav ? item.name : item.avtiveChildText}} -->
                            {{ item.name}}
                        </template>
                        <b-dropdown-item :active="avtiveNavRun && avtiveNavRun.text == child.name"  @click="onClickNavItem(child,item)" :key="cindex" v-for="(child,cindex) in item.children">{{child.name}}</b-dropdown-item>
                    </b-nav-item-dropdown>
                </template>
                
            </b-navbar-nav>
        </b-collapse>
        <b-navbar-nav class="ml-auto" v-if="brand && isShowLogin">
            <!-- <b-nav-item right>
               登录
            </b-nav-item> -->
            <b-nav-item right @click="login">
               登录
            </b-nav-item>
      </b-navbar-nav>
      <b-modal ref="my-modal" centered  hide-footer title="易企跑用户登录">
        <div class="d-block text-center">
            <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                <b-form-group
                    label="账号"
                    label-for="name"
                    description="请前往小程序，立即拥有账号"
                >
                    <b-form-input
                    id="name"
                    v-model="form.name"
                    type="text"
                    required
                    placeholder="请输入账号"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    label="密码"
                    label-for="password"
                >
                     <b-form-input
                    id="password"
                    v-model="form.password"
                    label="密码"
                    type="password"
                    required
                    placeholder="请输入密码"
                    ></b-form-input>
                </b-form-group>
                <!-- <b-form-group id="input-group-4">
                    <b-form-checkbox-group v-model="form.checked" id="checkboxes-4">
                    <b-form-checkbox value="me">Check me out</b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group> -->

                <b-button type="submit" variant="primary">登录</b-button>
                <!-- <b-button type="reset" variant="danger">注册</b-button> -->
            </b-form>
        </div>
        </b-modal>
    </b-navbar>
  </template>
  
  <script>
  
  import { login } from '@/api/api.js'
  export default {
    name: 'navigation',
    props: {
        navs: {
            type:Array,
            default(){
                return null
            }
        },
        brand:{
            type:Object,
            default(){
                return null
            }
        },
        variant:{
            type:String,
            default(){
                return 'cdark'
            }
        },
        type:{
            type:String,
            default(){
                return 'dark'
            }
        },
        sticky:{
            type:Boolean,
            default(){
                return true
            }
        },
        fixed:{
            type:String,
            default(){
                return 'top'
            }
        },
        navItemAlign:{
            type:String,
            default(){
                return 'left'
            }
        },
        toggle:{
            type:Boolean,
            default(){
                return true
            }
        }
    },

    data() {
      return {
        form: {
          email: '',
          name: '',
          password: null
        },
        foods: [{ text: 'Select One', value: null }, 'Carrots', 'Beans', 'Tomatoes', 'Corn'],
        show: true,
        avthveNav:null
        
      }
    },
    computed:{
        avtiveNavRun(){
            let nav = this.avthveNav ||  JSON.parse(sessionStorage.getItem('avtiveNav')) 
            return this.bxDeepClone(nav)
        },
        isShowLogin(){
            let nav = sessionStorage.getItem('basisInfo') ?  JSON.parse(sessionStorage.getItem('basisInfo')).include_reg_login : null
            return nav == '是'
        }
    },
    methods:{
        onClickNavItem(e,parent){
            let self = this
            console.log(e.temp_file_name)
            let path = e.temp_file_name
            let nav = e
            if(parent){
                parent['avtiveChildText'] = e.name
                path + '/'
                nav = parent
            }else{
                e['avtiveChildText'] = e.name
            }
            this.avthveNav = this.bxDeepClone(nav)
            sessionStorage.setItem('avtiveNav',JSON.stringify(nav))
            if(path !== '#'){
                self.$router.push(path,(sce => {
                console.log('跳转异常：',sce)
                }),(err => {
                console.log('跳转异常：',err)
                }))
            }
            
        },
        onSubmit(evt) {
            evt.preventDefault()
            // alert(JSON.stringify(this.form))
            let req = [{
                serviceName:"srvuser_login",
                data:[{
                    pwd: this.form.password,
                    user_no: this.form.name
                }]
            }]
            login(req).then((res) =>{
                console.log('----',res)
                if(res.state == 'SUCCESS'){
                    let token = res.response[0].response.bx_auth_ticket
                    this.$store.commit('setToken',token)
                    sessionStorage.setItem('bx_auth_ticket',token)
                    this.hideModal()
                    this.$router.push({name:'home',path:'/'})
                }
                // let res = {
                //     "state": "SUCCESS",
                //     "resultMessage": "操作成功",
                //     "resultCode": "SUCCESS",
                //     "serviceInfo": null,
                //     "data": null,
                //     "response": [
                //         {
                //             "serviceName": "srvuser_login",
                //             "code": null,
                //             "response": {
                //                 "bx_auth_ticket": "xabxdzkj-5e3e7b84-721f-4202-b06f-38e27b5b6ef7",
                //                 "login_user_info": {
                //                     "user_no": "wangyh",
                //                     "dept_no": "bx100sys",
                //                     "parent_dept_no": null,
                //                     "email": "80110410@qq.com",
                //                     "mobile": "15389292839",
                //                     "user_type": "内部用户",
                //                     "id_card": "610221198888881111",
                //                     "real_name": "王永宏",
                //                     "user_disp": "王永宏/11000003",
                //                     "create_time": "2021-09-09 10:50:40",
                //                     "create_user": "admin",
                //                     "modify_user": "wangyh",
                //                     "modify_time": "2022-05-31 14:51:39",
                //                     "user_state": "正常",
                //                     "login_control": "PC,IOS,ANDROID",
                //                     "signature": null,
                //                     "del_flag": "否",
                //                     "applications": [
                //                         {
                //                             "id": 1,
                //                             "application": "xabxkj_ai_platform",
                //                             "application_name": "企业数字化乐高底座云平台",
                //                             "defaut_appli": "是",
                //                             "create_time": "2022-03-18 21:51:28",
                //                             "create_user": "yaojz",
                //                             "create_user_disp": "姚金柱/11000001",
                //                             "modify_time": "2023-02-15 09:43:34",
                //                             "modify_user": "yaojz",
                //                             "modify_user_disp": "姚金柱/11000001",
                //                             "del_flag": "否"
                //                         }
                //                     ],
                //                     "login_port_type": "m",
                //                     "otherTenantInfos": [],
                //                     "application": "xabxkj_ai_platform",
                //                     "tenant": "S0000000000",
                //                     "tenantInfos": [],
                //                     "login_user_type": "user",
                //                     "_dept_info": {
                //                         "id": 1,
                //                         "dept_no": "bx100sys",
                //                         "dept_name": "百想科技",
                //                         "dept_full_name": null,
                //                         "parent_no": null,
                //                         "is_leaf": "否",
                //                         "path": "/bx100sys/",
                //                         "path_name": null,
                //                         "dept_tel": null,
                //                         "dept_head": "admin",
                //                         "remark": null,
                //                         "dept_type": "真实",
                //                         "dept_class": null,
                //                         "dept_level": null,
                //                         "reserve_col1": null,
                //                         "reserve_col2": null,
                //                         "reserve_col3": null,
                //                         "reserve_col4": null,
                //                         "reserve_col5": null,
                //                         "reserve_col6": null,
                //                         "reserve_col7": null,
                //                         "reserve_col8": null,
                //                         "reserve_col9": null,
                //                         "reserve_col10": null,
                //                         "reserve_col11": null,
                //                         "reserve_col12": null,
                //                         "reserve_col13": null,
                //                         "reserve_col14": null,
                //                         "reserve_col15": null,
                //                         "biz_path": null,
                //                         "create_user": "admin",
                //                         "create_time": "2020-01-09 17:37:03",
                //                         "modify_user": null,
                //                         "modify_time": "2020-01-09 17:37:03",
                //                         "create_user_disp": "管理员/admin",
                //                         "modify_user_disp": null,
                //                         "del_flag": "否"
                //                     },
                //                     "authorized_users": [],
                //                     "roles": [
                //                         "kangbainian_admin",
                //                         "platform_user",
                //                         "fyzh_mgr",
                //                         "spocp_mgmt",
                //                         "park_admin",
                //                         "admin",
                //                         "store_rd",
                //                         "app_fyzhmd_admin",
                //                         "dataanalysis_mgr",
                //                         "portal_mgr",
                //                         "person_biz_admin",
                //                         "clys_admin",
                //                         "yiqipao_admin",
                //                         "DEVE_LOPER",
                //                         "front_dev",
                //                         "yiqipao_devadmin",
                //                         "fyzh_md_dzh",
                //                         "gyc_admin",
                //                         "store_mgr",
                //                         "corp_biz_admin",
                //                         "health_admin",
                //                         "xlhl_manager",
                //                         "jwsmzx_admin",
                //                         "zhxq_admin",
                //                         "health_store_manager",
                //                         "vip_manage",
                //                         "spocp_dev",
                //                         "bdys_manager",
                //                         "health_store_cus_mgr",
                //                         "hotel_store_mgr",
                //                         "shop_manage",
                //                         "daq_manager",
                //                         "person_rd_admin",
                //                         "fyzh_md_dianyuan",
                //                         "tg_ptxe",
                //                         "clys_dev_admin",
                //                         "xlhl_rd",
                //                         "xlhl_mgmt",
                //                         "mendianadmin"
                //                     ]
                //                 },
                //                 "expire_time": 1800
                //             },
                //             "resultMessage": null,
                //             "child_data_list": null
                //         }
                //     ]
                // }
                
            })
        },
        onReset(evt) {
            
        },
        login(){
            this.showModal()
        },
        showModal() {
        this.$refs['my-modal'].show()
      },
      hideModal() {
        this.$refs['my-modal'].hide()
      },
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style >
  .navbar-dark .navbar-nav .nav-link{
    color: #fff!important;
  }
.navbar-dark .navbar-nav .nav-item .nav-link.active{
    
    font-weight: 400 !important;
}
.navbar-dark .navbar-nav .nav-item.b-nav-dropdown.active .nav-link,.navbar-dark .navbar-nav .nav-item .nav-link.active{
    color: #fff;
    background-color: #1268b5 !important;
}
.navbar-dark .navbar-nav .nav-item.b-nav-dropdown .dropdown-menu .dropdown-item,.navbar-dark .navbar-nav .nav-item.b-nav-dropdown .dropdown-menu{
    color: #fff;
    background-color: #1268b5 !important;
}
.navbar-nav.ml-auto{
    color: #fff;
    background-color:rgb(13, 115, 207) !important;
}
  </style>
  